import Axios from 'axios';

export default {
  getStudentCards(studentId) {
    return Axios.get('/admin/student_cards', {
      params: {
        student_id: studentId,
      },
    }).then(({ data }) => data);
  },
};
